import {BackendServer} from "../objects/BackendServer"

export const BACKEND_SERVERS: Array<BackendServer> = [
    { name: "Produktiv", url: "https://bemusterung.heimerl-bau.de/api/v1" },
    { name: "Test", url: "https://heimerl.felix.enterprises/api/v1" },
    { name: "Entwicklung", url: "http://localhost:3333/v1" }
]